import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import CreateTrip from './components/CreateTrip';
import TripDetails from './components/TripDetails';
import FirebaseTest from './components/FirebaseTest';
import TestFirebaseConnection from './components/TestFirebaseConnection';
import SimpleCreateTrip from './SimpleCreateTrip';
import OfflineTest from './OfflineTest';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/create-trip" element={<PrivateRoute><CreateTrip /></PrivateRoute>} />
            <Route path="/simple-create-trip" element={<PrivateRoute><SimpleCreateTrip /></PrivateRoute>} />
            <Route path="/offline-test" element={<PrivateRoute><OfflineTest /></PrivateRoute>} />
            <Route path="/trip/:id" element={<PrivateRoute><TripDetails /></PrivateRoute>} />
            <Route path="/test-firebase" element={<FirebaseTest />} />
            <Route path="/test-connection" element={<PrivateRoute><TestFirebaseConnection /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
